import { defineStore } from 'pinia';
import { axiosInstance as axios } from '../plugins/axios';
import { usePlanStore } from './planStore';

export const useDestinationStore = defineStore('destinationStore', {
    state: () => {
        return {
            loading: false,
            selectedDestinations: [{}],
            destinations: [],
            popularDestinations: [],
            monthPlanDestinationApiIds: [198, 180],
            isMultiDestinationEnabled: false,
        }
    },
    persist: {
        pick: ['selectedDestinations', 'isMultiDestinationEnabled']
    },
    getters: {
        getDestinations: (state) => state.destinations,
        getSelectedDestinations: (state) => state.selectedDestinations,
        getPopularDestinations: (state) => state.popularDestinations,
        getMonthPlanDestinationApiIds: (state) => state.monthPlanDestinationApiIds,

        mainSelectedDestination: (state) => {
            return state.selectedDestinations.length > 0 ? state.selectedDestinations[0] : {};
        },

        getDestinationsForDropdown: (state) => {
            let items = state.destinations.map(destination => ({
                label: destination.name,
                value: destination.id
            }));

            let selectedDestinations = state.selectedDestinations.filter(destination => {
                return destination?.id;
            }).map(destination => ({
                label: destination.name,
                value: destination.id
            }));

            return [...items, ...selectedDestinations];
        },
        validationMessage: (state) => {
            const emptyDestinations = state.selectedDestinations.filter(destination => {
                return !destination?.id;
            });

            if (emptyDestinations.length > 0) {
                return "Please select a destination.<br>";
            }
        },
    },
    actions: {
        async fetchDestinations(payload) {
            try {
                const res = await axios.get(`/countries/search`, {
                    params: {
                        keywords: payload.query,
                        limit: payload.limit,
                    }
                });

                this.destinations = res.data;
                return this.destinations;
            } catch (error) {
                console.error("Error while fetching search results:", error);
                return error;
            }
        },
        async fetchPopularDestination(payload) {
            try {
                const res = await axios.get(`/countries/popular`, {
                    params: {
                        limit: payload.limit,
                    }
                });
                this.popularDestinations = res.data;
            } catch (error) {
                console.error("Error while fetching popular destinations:", error);
                return error;
            }
        },

        setSelectedDestination(payload) {
            this.selectedDestinations = payload.destinations;
        },
        setSelectedDestinationByIndex(payload) {
            this.selectedDestinations[payload.index] = payload.destination;

            const planStore = usePlanStore();
            planStore.setPlanByIndex({index: payload.index, plan: {}});
        },
        pushSelectedDestination(payload) {
            this.selectedDestinations.push(payload.destination);
        },
        popSelectedDestination() {
            if (this.selectedDestinations.length > 1) {
                this.selectedDestinations.pop();
            }
        },
        setFirstSelectedDestination(payload) {
            this.selectedDestinations[0] = payload.destination;
            
            const planStore = usePlanStore();
            planStore.setPlanByIndex({index: 0, plan: {}});
        },
        toggleIsMultiDestinationEnabled() {
            this.isMultiDestinationEnabled = !this.isMultiDestinationEnabled;
        },

        findDestinationById(payload) {
            return this.destinations.find((destination) => destination.id === payload.destination_id);
        },
    },
})